export default "__VITE_ASSET__DnzOWgYj__"